import '@unocss/reset/tailwind-compat.css';

import { pocketMock } from 'pocket-mocker'
import { createApp } from 'vue'
import router from './router';
import store from './store';
import App from './App.vue';

import 'lazysizes';

import 'virtual:uno.css';

// 样式通过 arco-plugin 插件导入。详见 vite.config.ts
// https://arco.design/docs/designlab/use-theme-package
import '@/assets/style/global.scss';

if (import.meta.env.MODE === 'development') { pocketMock() }

const app = createApp(App);

app.use(router);
app.use(store);

app.mount('#app');
